import axios from '@utils/http'

export const state = {
  cached: [],
}

export const getters = {}

export const mutations = {
  CACHE_USER(state, newUser) {
    state.cached.push(newUser)
  },
}

export const actions = {
  updateUser({ commit, state, rootState }, { user }) {
    return axios
      .post(`/api/end_user/users/${user.id}`, user)
      .then((response) => {
        const user = response.data
        commit('CACHE_USER', user)
        return user
      })
  },
  getDropHistory({ commit, state, rootState }, { user }) {
    return axios
      .get(`/api/end_user/users/${user.id}/dropHistory`)
      .then((response) => {
        return response.data
      })
  },
    cancelSubscription({ commit, state, rootState }) {
        return axios
            .post(`/api/end_user/cancelSubscription`)
            .then((response) => {
                return response.data
            })
  }
}

